import React from 'react'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export function ApplicationInsightsTools({ instrumentationKey }) {
    React.useEffect(() => {
        const appInsights = new ApplicationInsights({
            config: {
                instrumentationKey,
                enableAutoRouteTracking: true,
                disableTelemetry: instrumentationKey === "none"
            }
        })

        appInsights.loadAppInsights()
        appInsights.trackPageView()
        window.appInsights = appInsights
    }, [])

    return null
}